<template>
  <div style="width: 100%">
    <div class="upload_holder" ref="input">
      <transition name="fade">
        <div v-if="!load" class="upload_click" @click="startUpload()">
          <img src="@/assets/img/add.svg" />
          <p>Upload {{ input.label }} here.</p>
        </div>
      </transition>

      <transition name="fade">
        <div v-if="load" class="loading">
          <img src="@/assets/img/loader.gif" />
          <p>loading...</p>
        </div>
      </transition>

      <input ref="upload" type="file" class="hide_upload" @change="uploadImage" />
    </div>

    <transition name="fade">
      <div v-if="media && media.length && !load" class="images">
        <template v-for="(img, i) in media">
          <div class="img" v-if="img.type.includes('image')">
            <img :src="img.url" />
            <p @click="removeImage(i)" class="remove text_btn">Remove</p>
          </div>
          <div class="img" v-if="img.type.includes('pdf')">
            <pdf class="pdf-renderer" :src="img.url" style="display: inline-block; width: 25%"></pdf>
            <p @click="removeImage(i)" class="remove text_btn">Remove</p>
          </div>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import { db, storage } from "@/config/firebaseInit";

export default {
  components: {
    pdf
  },
  props: ["input", "questionIndex", "answerKey"],
  data() {
    return {
      file: null,
      load: false,
      media_type: "image",
      media: []
    };
  },
  created() {
    this.saveAnswer();
    this.media = this.input.value;
    if (this.$store.state.phase != "Application Approval") {
      if (this.$store.state.answers) {
        let media = this.$store.state.answers[this.answerKey];
        if (media) this.media = media;
      } else {
        let data = {};
        data[this.answerKey] = [];
        this.$store.commit("setAnswers", data);
      }
      this.saveAnswer();
    }
  },
  methods: {
    startUpload() {
      if (!this.load) this.$refs.upload.click();
    },
    uploadImage(e) {
      let vm = this;
      this.upload = null;
      vm.load = null;
      setTimeout(function() {
        vm.load = true;
      }, 500);
      let media = e.target.files[0];
      let fileName = media.name;
      let fileSize = media.size;
      let type = media.type;
      let reader = new FileReader();
      this.media_type = type;

      reader.readAsDataURL(media);
      reader.onload = e => {
        let storageRef = storage.ref(`bankStatements/${Date.now()}`);
        let uploadTask = storageRef.put(media);
        let blob = e.target.result;

        uploadTask.on(
          "state_changed",
          snapshot => {},
          error => {
            console.log(error);
            vm.logoLoad = false;
            vm.load = false;
            alert("could not upload logo, please try again.");
          },
          snapshot => {
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
              let media = {
                url: downloadURL,
                type: type
              };
              this.media.push(media);
              vm.load = null;
              this.saveAnswer();

              setTimeout(function() {
                vm.load = false;
              }, 500);
            });
          }
        );
      };
    },
    saveAnswer(e) {
      this.$emit(
        "updateAnswer",
        this.questionIndex,
        this.answerKey,
        this.media
      );
    },
    removeImage(i) {
      this.media.splice(i, 1);
    }
  },
  watch: {
    media() {
      this.file = this.media;
    }
  }
};
</script>

<style lang="scss" scoped>
.upload_holder {
  width: 100%;
  padding: 30px;
  background-color: white;
  max-width: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 15px;
  transition: border 0.3s;
}

.upload_holder.error {
  border-bottom: 2px solid red;
}

.upload_holder img {
  height: 40px;
  width: auto;
  flex: none;
}

.hide_upload {
  position: absolute;
  z-index: -2;
}

.upload_click,
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.loading {
  img {
    height: 100px;
  }
}

.upload_click .md-icon {
  font-size: 53px !important;
  opacity: 0.5;
}

.upload_click p {
  line-height: 1.3;
  max-width: 300px;
  text-align: center;
  opacity: 0.5;
  margin-top: 20px;
  margin-bottom: 0;
}

.rotate {
  font-size: 40px !important;
  -webkit-animation: loading 1s infinite linear;
}

.success p {
  text-align: center;
  margin-bottom: 0;
}

.success img {
  width: auto;
  height: 100px;
}

@-webkit-keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.remove {
  color: #f44336;
  font-size: 14px;
  cursor: pointer;
}

.images {
  justify-content: flex-start;
  display: flex;
  .img {
    width: 48%;
    margin-right: 2%;
    text-align: center;
    margin-bottom: 20px;
    background: white;
    padding: 10px;
    img {
      max-width: 100%;
    }
    span {
      width: 100% !important;
    }
  }
}
</style>
